// fsm-oms-frontend/src/components/auth/epcLoginPalette.ts
/**
 * Sovereign Emerald palette — the colour system for the cream
 * EPC cinematic login. See
 * docs/superpowers/specs/2026-06-09-epc-cinematic-login-redesign-design.md.
 */

// Background paper + bright highlights
export const IVORY_PAPER = '#F2EADB';
export const CANDLELIGHT = '#F8F2E2';

// Deep ink + brand greens
export const RACING_GREEN = '#0B3B2E';
export const BRAND_GREEN = '#339274';
export const BOTTLE_GREEN = '#1F5A47';

// Metallic accent (replaces lime everywhere)
export const CHAMPAGNE = '#C9A961';

// Fine engraving + microprint
export const ESPRESSO_INK = '#2A1F17';

// Equipment + slate (kept from existing palette)
export const SLATE_DARK = '#3D4452';
export const SLATE_MID = '#5A6275';
export const SLATE_LIGHT = '#94A3B8';
export const SLATE_PANEL = '#2D3340';

// Earth tones (for ground, mountains, foliage shadows)
export const GROUND_TAUPE = '#E6DCC8';
export const GROUND_SHADOW = '#D6CBB1';
export const HILL_SAGE = '#A9C49C';
export const HILL_SAGE_DEEP = '#8FB48A';
export const HILL_SAGE_SHADOW = '#6FA08C';
export const MOUNTAIN_DISTANT = '#C8D9CC';
export const MOUNTAIN_MID = '#A6BFAA';

// Hazard / signage accents (used sparingly: rigger vests, cones, danger sign)
export const HI_VIS_ORANGE = '#F08A3E';
export const RED_AVIATION = '#E63946';
export const YELLOW_WARNING = '#FFD23F';

// Skin tones
export const SKIN_LIGHT = '#F2C29C';
export const SKIN_MID = '#D89870';
export const SKIN_DEEP = '#8C5A3F';

// Typography ink shades
export const INK_DEEP = RACING_GREEN;
export const INK_MID = '#5A6B65';

// Pixel/viewBox constants
export const VIEW_W = 900;
export const VIEW_H = 700;
export const HORIZON = 470;
